(function () {
  'use strict';

  function getContactMode(instance) {
    const store = instance._getStoreConfig();
    if (store.allowEmailContact && store.allowMobileContact) return 'both';
    if (store.allowMobileContact) return 'mobile';
    return 'email';
  }

  function escapeHtml(instance, value) {
    if (instance && typeof instance._escapeHtml === 'function') return instance._escapeHtml(value);
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getUiCopy(instance) {
    const t = instance.config && instance.config.i18n || {};
    const mode = getContactMode(instance);
    const emailMethodLabel = t.contactMethodEmail || 'Email';
    const mobileMethodLabel = t.contactMethodMobile || 'WhatsApp';

    if (mode === 'mobile') {
      return {
        description: t.analysisDescriptionMobile || t.analysisDescriptionEmailOrMobile || t.analysis_description || '',
        placeholder: t.contactPlaceholderMobile || t.contactPlaceholderEmailOrMobile || t.contact_placeholder || '',
        optinText: t.optinTextMobile || t.optinTextEmailOrMobile || t.optin_text || '',
        skipLabel: t.skipContact || 'Skip for now',
        captureLabel: t.contactCaptureLabel || 'Where should we send it?',
        channels: [{ type: 'mobile', label: mobileMethodLabel }],
        deliveryLabel: t.deliveryLabel || 'Sending your consultation to',
        deliverySkippedLabel: t.deliveryLabelSkipped || 'Finalizing your consultation',
        emailMethodLabel,
        mobileMethodLabel
      };
    }

    if (mode === 'both') {
      return {
        description: t.analysisDescriptionEmailOrMobile || t.analysis_description || '',
        placeholder: t.contactPlaceholderEmailOrMobile || t.contact_placeholder || t.email_placeholder || '',
        optinText: t.optinTextEmailOrMobile || t.optin_text || '',
        skipLabel: t.skipContact || 'Skip for now',
        captureLabel: t.contactCaptureLabel || 'Where should we send it?',
        channels: [
          { type: 'email', label: emailMethodLabel },
          { type: 'mobile', label: mobileMethodLabel }
        ],
        deliveryLabel: t.deliveryLabel || 'Sending your consultation to',
        deliverySkippedLabel: t.deliveryLabelSkipped || 'Finalizing your consultation',
        emailMethodLabel,
        mobileMethodLabel
      };
    }

    return {
      description: t.analysisDescriptionEmail || t.analysis_description || '',
      placeholder: t.contactPlaceholderEmail || t.email_placeholder || t.contact_placeholder || '',
      optinText: t.optinTextEmail || t.optin_text || '',
      skipLabel: t.skipContact || 'Skip for now',
      captureLabel: t.contactCaptureLabel || 'Where should we send it?',
      channels: [{ type: 'email', label: emailMethodLabel }],
      deliveryLabel: t.deliveryLabel || 'Sending your consultation to',
      deliverySkippedLabel: t.deliveryLabelSkipped || 'Finalizing your consultation',
      emailMethodLabel,
      mobileMethodLabel
    };
  }

  function configureStep(instance) {
    const store = instance._getStoreConfig();
    const copy = getUiCopy(instance);
    const input = instance._getContactInput();
    const description = instance.querySelector('[data-contact-description]');
    const label = instance.querySelector('[data-contact-label]');
    const optin = instance.querySelector('[data-contact-optin]');
    const skipButton = instance.querySelector('[data-contact-skip]');
    const captureLabel = instance.querySelector('[data-contact-capture-label]');
    const channelList = instance.querySelector('[data-contact-channel-list]');

    if (description) description.textContent = copy.description || '';
    if (label) label.textContent = copy.placeholder || '';
    if (optin) optin.textContent = copy.optinText || '';
    if (captureLabel) captureLabel.textContent = copy.captureLabel || '';
    if (skipButton) {
      skipButton.textContent = copy.skipLabel || '';
      // Defer skip visibility ~5s so committed users self-select first.
      // Hides the abandonment ramp until after the user has had a moment
      // to actually consider entering their email.
      const skipAllowed = store.contactCaptureMode !== 'required';
      skipButton.hidden = true;
      if (skipAllowed) {
        if (instance._contactSkipDelayTimer) clearTimeout(instance._contactSkipDelayTimer);
        instance._contactSkipDelayTimer = setTimeout(function revealSkip() {
          if (instance.currentStep === 'email') skipButton.hidden = false;
        }, 5000);
      }
    }
    if (channelList) {
      channelList.innerHTML = Array.isArray(copy.channels)
        ? copy.channels.map(function renderChannel(channel) {
          return `<span class="consultation-completion__channel" data-contact-channel data-contact-type="${escapeHtml(instance, channel.type)}">${escapeHtml(instance, channel.label)}</span>`;
        }).join('')
        : '';
      channelList.hidden = !Array.isArray(copy.channels) || copy.channels.length === 0;
    }

    if (!input) return;

    const onlyMobile = store.allowMobileContact && !store.allowEmailContact;
    const onlyEmail = store.allowEmailContact && !store.allowMobileContact;
    input.placeholder = copy.placeholder || '';
    input.setAttribute('aria-label', copy.placeholder || '');
    input.required = instance._isContactCaptureRequired();
    input.autocomplete = onlyMobile ? 'tel' : 'email';
    input.inputMode = onlyMobile ? 'tel' : 'email';
    input.type = onlyEmail ? 'email' : 'text';
    syncInput(instance);
  }

  function getInvalidMessage(instance, contact) {
    const t = instance.config && instance.config.i18n || {};
    if (contact && contact.type === 'email') {
      return t.contactInvalidEmail || t.contactInvalid || 'Enter a valid email address.';
    }
    return t.contactInvalidPhone || t.contactInvalid || 'Enter a valid WhatsApp number.';
  }

  function syncInput(instance) {
    const input = instance._getContactInput();
    if (!input) return;

    const store = instance._getStoreConfig();
    const contact = instance._parseContactValue(input.value, { allowEmpty: true });
    const isPhone = contact.type === 'mobile' && !contact.empty;
    const onlyMobile = store.allowMobileContact && !store.allowEmailContact;
    const channels = Array.from(instance.querySelectorAll('[data-contact-channel]'));

    input.inputMode = isPhone || onlyMobile ? 'tel' : 'email';
    input.autocomplete = isPhone || onlyMobile ? 'tel' : 'email';
    input.setCustomValidity('');

    if (isPhone) {
      input.setAttribute('data-phone', 'true');
      input.setAttribute('dir', 'ltr');
    } else {
      input.removeAttribute('data-phone');
      input.removeAttribute('dir');
    }

    channels.forEach(function toggleChannel(channel) {
      const type = channel.getAttribute('data-contact-type') || '';
      const active = contact.empty
        ? (channels.length === 1 && type === (onlyMobile ? 'mobile' : 'email'))
        : type === contact.type;
      channel.classList.toggle('is-active', active);
    });
  }

  window.TaraConsultationContact = Object.freeze({
    getContactMode,
    getUiCopy,
    configureStep,
    getInvalidMessage,
    syncInput,
  });
})();
